/* eslint-disable import/no-default-export */
import Chance from 'chance';

import resume from './Resume';

const chance = new Chance();

export default () => {
  const id = chance.guid();
  return {
    resume: { ...resume(), id },
    id,
  };
};
